

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.EUgkhZYl.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/IHki7fMi.js","_app/immutable/chunks/CUEW_ppn.js","_app/immutable/chunks/BwpWoHbM.js","_app/immutable/chunks/DC8ybcx3.js","_app/immutable/chunks/D0QH3NT1.js","_app/immutable/chunks/C8t-7i39.js","_app/immutable/chunks/DzATuTuW.js","_app/immutable/chunks/C1FmrZbK.js","_app/immutable/chunks/DW5DwYHW.js","_app/immutable/chunks/Ch3kBo8q.js"];
export const stylesheets = ["_app/immutable/assets/3.C1Jrk2za.css"];
export const fonts = [];
